
































































































































































































































































































































































































import Table from "@/components/Table.vue";
import TableHeaderButtons from "@/components/TableHeaderButtons.vue";
import MeasureCard from "@/components/MeasureCard.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { Component } from "vue-property-decorator";
import Vue from "vue";
import { getDefaultPagination, DISPLAYMEASUREITEM } from "@/utils/store-util";
import { patientRecordsModule } from "@/store/modules/patientRecords";
import { placeModule } from "@/store/modules/place";
import { appModule } from "../store/modules/app";
import { formatValue, FloorValue, Rounding } from "@/utils/app-util";
import { formatMeasureAt } from "@/utils/app-util";
import http from "@/http/axios";
import 'vue-datetime/dist/vue-datetime.css'


Vue.filter("formatValue", function (value) {
  return formatValue(value);
});
Vue.filter("FloorValue", function (value) {
  return FloorValue(value);
})
Vue.filter("Round2second", function (value) {
  return Rounding(value,2);
})

Vue.filter("Round2first", function (value) {
  return Rounding(value,1);
})

Vue.filter("formatMeasureAt", function (value) {
  // {{new Date(measure_at * 1000).toLocaleString()
  return formatMeasureAt(value);
});

@Component({
  components: {
    Table,
    TableHeaderButtons,
    ConfirmDialog,
    MeasureCard,
  },
})
export default class PatientRecords extends Vue {
  public switchMask = true;
  public dialog = false;
  public addDataDialog = false;
  public editDialog = false;
  public datacategory = ['mental','blood','bone'];
  public datatype = [
    {
      'category': 'mental',
      'type':'minicog',
      'unit':''
    },
    {
      'category': 'mental',
      'type':'spmsq',
      'unit':''
    },
    {
      'category': 'mental',
      'type':'ad8',
      'unit':''
    },
    {
      'category': 'mental',
      'type':'bsrs',
      'unit':''
    },
    {
      'category': 'blood',
      'type':'ldl',
      'unit':'mg/dl'
    },
    {
      'category': 'blood',
      'type':'hba1c',
      'unit':'%'
    },
    {
      'category': 'blood',
      'type':'ast',
      'unit':'U/L'
    },
    {
      'category': 'blood',
      'type':'mg',
      'unit':'mg/dl'
    },
    {
      'category': 'blood',
      'type':'alb',
      'unit':'g/dl'
    },
    {
      'category': 'blood',
      'type':'hb',
      'unit':'g/dl'
    },
    {
      'category': 'blood',
      'type':'prompe',
      'unit':''
    },
    {
      'category': 'blood',
      'type':'fe',
      'unit':'mcg/dl'
    },
    {
      'category': 'blood',
      'type':'hdl',
      'unit':'mg/dl'
    },
    {
      'category': 'blood',
      'type':'ua',
      'unit':'mg/dl'
    },
    {
      'category': 'blood',
      'type':'cre',
      'unit':'mg/dl'
    },
    {
      'category': 'blood',
      'type':'tcho',
      'unit':'mg/dl'
    },
    {
      'category': 'bone',
      'type':'intactT',
      'unit':''
    },
    {
      'category': 'bone',
      'type':'stone',
      'unit':''
    },
    {
      'category': 'bone',
      'type':'osteoporosis',
      'unit':''
    },
    {
      'category': 'bone',
      'type':'biting',
      'unit':''
    },
    {
      'category': 'bone',
      'type':'fracture',
      'unit':''
    },
    {
      'category': 'bone',
      'type':'LossT',
      'unit':''
    },
    {
      'category': 'bone',
      'type':'caries',
      'unit':''
    },
  ];
  public alldata = {
    minicog:null,
    spmsq:null,
    ad8:null,
    bsrs:null,
    ldl:null,
    hba1c:null,
    ast:null,
    mg:null,
    alb:null,
    hb:null,
    prompe:null,
    fe:null,
    hdl:null,
    ua:null,
    cre:null,
    tcho:null,
    intactT:null,
    stone:null,
    osteoporosis:null,
    biting:null,
    fracture:null,
    LossT:null,
    caries:null
  };
  public dataitem = {
    type:'mental',
    machine_number:"",
    measure_at: new Date().toISOString()
  };
  public editItem = {
    event_title:"",
    event_type:"終止收案",
    measure_at: new Date().toISOString(),
    place:"",
    cause:""
  };
  public place = "";
  public event_type_items = [
    "終止收案",
    "住院",
    "其他事件"
  ];
  public measureTab = null;
  public displaymeasureItem = DISPLAYMEASUREITEM;
  public headers = [
    { text: "測量時間", sortable: false, value: "measure_at" },
    {
      text: "關鍵字",
      sortable: false,
      value: "zh",
      align: "start",
      width: "25%",
    },
    { text: "值", sortable: false, value: "value" },
    { text: "機器", sortable:false, value: "device"},
  ];

  public eventheaders = [
    {
      text: "事件時間",
      sortable: false,
      value: "measure_at",
      align: "start",
      width: "20%",
    },
    { text: "事件類別", sortable: false, width: "15%", value: "event_type" },
    { text: "事件", sortable: false, width: "15%", value: "event_title" },
    { text: "地點", sortable: false, width: "15%", value: "place" },
    { text: "原因", sortable: false, value: "cause" },
  ];

  public recordsOptions = {
    page: 1,
    q: "",
    order: "asc",
    sort: "",
    uuid: "",
    limit: 10,
    formatMeasureAt: true,
  };

  public eventsOptions = {
    page: 1,
    q: "",
    order: "asc",
    sort: "",
    uuid: "",
    limit: 10,
    formatMeasureAt: true,
  };


  get totalPages() {
    return patientRecordsModule.totalPages;
  }
  
  get totalEventPages() {
    return patientRecordsModule.totalEventPages;
  }

  get currentPage() {
    return patientRecordsModule.currentPage;
  }

  get EventcurrentPage() {
    return patientRecordsModule.EventcurrentPage;
  }

  get totalRecords() {
    return patientRecordsModule.totalRecords;
  }

  get totalEvents() {
    return patientRecordsModule.totalEvents;
  }

  get records() {
    return patientRecordsModule.records;
  }

  get events() {
    return patientRecordsModule.events;
  }

  get items() {
    return patientRecordsModule.items;
  }

  get loading() {
    return patientRecordsModule.loading;
  }

  get r_loading() {
    return patientRecordsModule.r_loading;
  }

  get e_loading() {
    return patientRecordsModule.e_loading;
  }

  get measurementTypes() {
    return patientRecordsModule.measurementTypes;
  }

  get patient() {
    return patientRecordsModule.patient;
  }

  get pagination() {
    return patientRecordsModule.pagination;
  }

  set pagination(pagination) {
      patientRecordsModule.setPagination(pagination);
    }

  get Eventpagination() {
    return patientRecordsModule.Eventpagination;
  }

  set Eventpagination(eventpagination) {
    patientRecordsModule.setEventPagination(eventpagination);
  }

  async created() {
    this.recordsOptions.formatMeasureAt = true;
    this.eventsOptions.formatMeasureAt = false;
    this.pagination = getDefaultPagination();
    this.Eventpagination = getDefaultPagination();
    this.recordsOptions.uuid = this.$router.currentRoute.params.id;
    this.eventsOptions.uuid = this.$router.currentRoute.params.id;
    await this.getPatientByUuid(this.recordsOptions.uuid);
    await this.updateTableData();
    await this.updateEventTableData();
    // console.log(this.patient);
    // console.log(this.editItem);
  }

  openDialog(){
    this.addDataDialog = true;
  }
  closeDataEdit(){
    this.dataitem = {
      type:'mental',
      machine_number:"",
      measure_at: new Date().toISOString()
    };
    this.alldata = {
      minicog:null,
      spmsq:null,
      ad8:null,
      bsrs:null,
      ldl:null,
      hba1c:null,
      ast:null,
      mg:null,
      alb:null,
      hb:null,
      prompe:null,
      fe:null,
      hdl:null,
      ua:null,
      cre:null,
      tcho:null,
      intactT:null,
      stone:null,
      osteoporosis:null,
      biting:null,
      fracture:null,
      LossT:null,
      caries:null
    };
    this.addDataDialog = false;
  }
  async saveDataEdit(){
    const params = {};
    params['data'] = {};
    params['type'] = this.dataitem.type;
    params['machine_number'] = this.dataitem.machine_number;
    for(const x of this.datatype.filter(c => c.category === this.dataitem.type)){
      if(this.has_value(this.alldata[x.type])){
        params['data'][x.type] = this.alldata[x.type]
      }
    }
    params['measure_at'] = new Date(this.dataitem.measure_at).getTime() / 1000;
    if (Object.keys(params['data']).length > 0) {
      const result = await http.post("/user/"+this.$router.currentRoute.params.id+"/record",params);
      if (result) {
        if (result.data.status === "Success") {
          appModule.sendSuccessNotice("修改成功");
        } else {
          appModule.sendErrorNotice("修改失敗");
        }
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
      this.closeDataEdit();
      await this.getPatientByUuid(this.recordsOptions.uuid);
      await this.updateTableData();
      await this.updateEventTableData();
    }
    else this.closeDataEdit();
  }


  changeToSarcopeniaPage() {
    this.$router.push({
      name: `肌少症判斷`,
      params: {
        id: this.recordsOptions.uuid,
      },
    });
  }

  async getPatientByUuid(uuid) {
    await patientRecordsModule.getPatientByUuid(uuid);
    await placeModule.placeList();
    if (this.patient.user.place !== null) {
      this.place = await placeModule.codetoPlace(this.patient.user);
    }
  }

  async updateTableData() {
    await patientRecordsModule.getPatientRecordByUuid(this.recordsOptions);
  }

  async updateEventTableData() {
    await patientRecordsModule.getPatientEventByUuid(this.eventsOptions);
  }

  async newEvent() {
    this.editDialog = true;
  }

  closeEdit() {
    this.editItem = {
      event_title:"",
      event_type:"終止收案",
      measure_at:new Date().toISOString(),
      place:"",
      cause:""
    };
    this.editDialog = false;
  }

  has_value(item){
    return (item===null)
      ? false
      : (item===undefined)
        ? false
        : (item==="")
          ? false
          : true;
  }

  async saveEdit() {
    if(!this.has_value(this.editItem.event_title)||!this.has_value(this.editItem.measure_at)){
      appModule.sendErrorNotice("失敗，請完整填完項目");
    }
    const params = {}
    params['measure_at'] = new Date(this.editItem.measure_at).getTime() / 1000;
    params['event_title'] = this.editItem.event_title;
    params['event_type'] = this.editItem.event_type;
    if(this.has_value(this.editItem.cause)) params['cause'] = this.editItem.cause;
    if(this.has_value(this.editItem.place)) params['place'] = this.editItem.place;
    // console.log(params);
    const result = await http.post("/user/"+this.$router.currentRoute.params.id+"/event",params);
    if (result) {
      if (result.data.status === "Success") {
        appModule.sendSuccessNotice("修改成功");
      } else {
        appModule.sendErrorNotice("修改失敗");
      }
    } else {
      appModule.sendErrorNotice("修改失敗");
    }
    this.closeEdit();
    await this.getPatientByUuid(this.recordsOptions.uuid);
    await patientRecordsModule.getPatientEventByUuid(this.eventsOptions);
  }

  changeToChartPage() {
    this.$router.push({ name: "個案紀錄圖表" });
  }
  changeToLifeStylePage(){
    this.$router.push({name:"生活型態紀錄"})
  }
  cancel() {
    this.$router.push({ 
      name: "個案名單",
      params: {
        chineseplace: this.$router.currentRoute.params.chineseplace,
        q: this.$router.currentRoute.params.q,
        page: this.$router.currentRoute.params.page,
      },
    });
  }
}
